const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const SERVER_BASE = API_BASE.replace(/\/api\/?$/, '');

export const resolveMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('/uploads/')) return `${SERVER_BASE}${url}`;
  return url;
};

/**
 * Get thumbnail URL — supports both legacy local and B2 thumbnails
 * @param {string} mediaUrl - the media_url from content record
 * @param {string} thumbnailKey - B2 thumbnail key (if stored in B2)
 * @param {{ downloadUrl: string, bucketName: string, token: string }} thumbAuth - B2 thumbnail auth
 */
/**
 * Get avatar URL — supports both legacy local and B2 avatars
 */
export const getAvatarUrl = (avatarUrl, avatarAuth) => {
  if (!avatarUrl) return null;
  // B2 avatar (starts with "avatars/")
  if (avatarUrl.startsWith('avatars/') && avatarAuth) {
    return `${avatarAuth.downloadUrl}/file/${avatarAuth.bucketName}/${avatarUrl}?Authorization=${avatarAuth.token}`;
  }
  // Legacy local avatar
  if (avatarUrl.startsWith('/uploads/')) {
    return `${SERVER_BASE}${avatarUrl}`;
  }
  // Already a full URL
  if (avatarUrl.startsWith('http')) return avatarUrl;
  return null;
};

export const getThumbnailUrl = (mediaUrl, thumbnailKey, thumbAuth) => {
  // B2 thumbnail
  if (thumbnailKey && thumbAuth) {
    return `${thumbAuth.downloadUrl}/file/${thumbAuth.bucketName}/${thumbnailKey}?Authorization=${thumbAuth.token}`;
  }
  // Legacy local thumbnail
  if (!mediaUrl || !mediaUrl.startsWith('/uploads/videos/')) return null;
  const filename = mediaUrl.split('/').pop();
  const thumbName = filename.replace(/\.[^.]+$/, '.jpg');
  return `${SERVER_BASE}/uploads/thumbnails/${thumbName}`;
};
